import { render } from "./AfterSalesList.vue?vue&type=template&id=68abffea&scoped=true"
import script from "./AfterSalesList.vue?vue&type=script&lang=js"
export * from "./AfterSalesList.vue?vue&type=script&lang=js"

import "./AfterSalesList.vue?vue&type=style&index=0&id=68abffea&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\30822\\Desktop\\LQ\\git\\度才子\\supplier_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68abffea"]])

export default __exports__